module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Right-2-99edd58399094ef9b72b376afce3a3ce.svg";